module.exports = __webpack_public_path__ + "img/ico_checked.cc668bf3.svg";